import { getCountryCallingCode, CountryCode } from 'libphonenumber-js'

/**
 * Formats a phone number with its country code
 * @param phoneCode - The country code (ISO 3166-1 alpha-2)
 * @param phoneNumber - The phone number without country code
 * @returns Formatted phone number with country code (e.g., +1234567890)
 */
export const formatPhoneNumber = (
	phoneCode: string,
	phoneNumber: string
): string => {
	const callingCode = getCountryCallingCode(phoneCode as CountryCode)
	return `+${callingCode}${phoneNumber}`
}

/**
 * Splits a full phone number into country code and number
 * @param fullPhoneNumber - The full phone number with country code (e.g., +1234567890)
 * @param defaultCountry - Default country code to use if parsing fails
 * @returns Object with phoneCode and phoneNumber
 */
export const splitPhoneNumber = (
	fullPhoneNumber: string,
	defaultCountry: string = 'US'
): { phoneCode: string; phoneNumber: string } => {
	// This is a simplified implementation
	// For production, consider using libphonenumber-js's parsePhoneNumber
	if (!fullPhoneNumber || !fullPhoneNumber.startsWith('+')) {
		return {
			phoneCode: defaultCountry,
			phoneNumber: fullPhoneNumber || '',
		}
	}

	// Try to extract the country code
	// This is a simplified approach and may not work for all cases
	// For production, use a more robust implementation
	const plusRemoved = fullPhoneNumber.substring(1)

	// This approach is simplified and might not work for all cases
	return {
		phoneCode: defaultCountry, // Hard to determine without more context
		phoneNumber: plusRemoved,
	}
}
